export function htmlToPlaintext(text : string) : string {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
}